import { render, staticRenderFns } from "./home.vue?vue&type=template&id=0053e2ba&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.sass?vue&type=style&index=0&id=0053e2ba&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0053e2ba",
  null
  
)

export default component.exports